/* eslint-disable @typescript-eslint/no-unused-vars */
import { CollectionOpenSearch } from '@europrocurement/l2d-domain';
import { createContext, useContext } from 'react';

export type OrderAction =
    | 'manageGroups'
    | 'cancel'
    | 'validate'
    | 'suspend'
    | 'unsuspend'
    | 'export'
    | 'urgent'
    | 'assign'
    | 'selectGreffe'
    | undefined;

let currentAction: OrderAction;

const orders: Array<CollectionOpenSearch> = [];
const ordersUpdated: Array<CollectionOpenSearch> = [];

const setOrdersUpdated: React.Dispatch<
    React.SetStateAction<Array<CollectionOpenSearch>>
> = () => {};

const triggerAction = (action: OrderAction, selectedOrder: Array<CollectionOpenSearch>) => {};
const cancelCurrentAction = () => {};
const confirmCurrentAction = () => {};
const updatingOrder = false;

const OrderActionContext = createContext({
    orders,
    currentAction,
    ordersUpdated,
    setOrdersUpdated,
    triggerAction,
    cancelCurrentAction,
    confirmCurrentAction,
    updatingOrder,
});

export const useOrderActionContext = () => useContext(OrderActionContext);

export default OrderActionContext;
